export default __webpack_public_path__ + "static/media/2023-brestovat-hol.c9899ac8.jpg";